import React from 'react';


const NotFound = () => {
    return (
        <div>
         
            <div style={{textAlign:'center',margin:'10rem'}}>
            <h1>File Not found or Invalid path.. </h1>
            <h2>Please Try again with valid data. </h2>
            <h1>Thanks</h1>
            </div>
         
        </div>
    );
};

export default NotFound;